<!--
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-08-01 17:51:15
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2023-08-04 09:15:14
-->
<template>
  <div class="con-wrap">
    <List :accountType="accountType" />
  </div>
</template>

<script>
import List from "@/components/RegionAccount/List";
export default {
  name: "ProvinceManageList",
  components: { List },
  data() {
    return {
      accountType: "province",
    };
  },
};
</script>
<style lang="scss" scoped>
.con-wrap {
  overflow: auto;
}
</style>
